export const calculationIssueLabels = {
  ROOT_DEPTH_MISSING: 'Profondeur des racines manquante ou invalide.',
  DEPLETION_FRACTION_INVALID: "Fraction d'épuisement du sol invalide (entre 0 et 100 %).",
  RAINFALL_EFFICIENCY_INVALID: 'Efficacité de pluie manquante ou invalide (0 à 100 %).',
  SOIL_RUMAX_MISSING: 'Réserve utile du sol manquante ou invalide.',
  SOIL_ZONE_MISSING_OR_AMBIGUOUS: 'Sélectionnez une seule zone de sol pour cette culture.',
  SOIL_CAPACITY_INVALID: 'Capacité hydrique du sol invalide : vérifiez sol et racines.',
  IRRIGATION_CONFIGURATION_MISSING_OR_AMBIGUOUS: "Sélectionnez une installation d'irrigation pour la culture.",
  IRRIGATION_CONFIGURATION_MISSING: "Efficacité d'irrigation manquante ou invalide (plus de 0 à 100 %).",
  IRRIGATION_FLOW_MISSING: "Débit d'irrigation ou nombre de goutteurs manquant ou invalide.",
  IRRIGATION_TYPE_UNSUPPORTED: "Calcul suspendu : le débit et la surface de ce type d'installation doivent être qualifiés par votre ingénieur.",
  PLANT_AREA_MISSING: 'Surface mouillée de référence manquante ou invalide (m², cohérente avec les goutteurs).',
  IRRIGATED_AREA_MISSING: 'Surface irriguée manquante ou invalide (ha).',
  WEATHER_DATA_MISSING: 'Données météo indisponibles : aucun conseil ne peut être calculé.',
  ET0_MISSING: "Évapotranspiration météo manquante pour le jour indiqué.",
  RAINFALL_MISSING: 'Pluie météo ou mesure manuelle manquante pour le jour indiqué.',
  RECALCULATION_REQUIRED: 'Relancez le calcul pour obtenir des recommandations vérifiées.',
  CALCULATION_REQUIRES_ATTENTION: 'Vérifiez les paramètres et relancez le calcul.',
  CALCULATION_INPUTS_CHANGED: 'Les données ont changé pendant le calcul. Relancez-le.',
  IRRIGATION_CHANGED_RECALCULATION_REQUIRED: 'Irrigation modifiée : recalcul nécessaire.',
  RAINFALL_CHANGED_RECALCULATION_REQUIRED: 'Pluie modifiée : recalcul nécessaire.',
  IRRIGATION_DOSE_DURATION_CONFLICT: 'La dose et la durée saisies ne correspondent pas au débit configuré.',
};
export const calculationIssueText = code => {
  const [key,date] = String(code).split(':');
  return `${calculationIssueLabels[key] || key}${date ? ` (${date})` : ''}`;
};
